module.exports = __webpack_public_path__ + "img/country.40efcda0.svg";